<template>
    <NuxtLink
        :to="to"
        :class="{
            'max-w-[11.25rem] max-lg:max-w-[9.8rem]': size === 'large',
            'w-full': size === 'medium',
            '': size === 'small',
        }"
        class="group block w-full">
        <div
            :class="{
                'h-[8.75rem] w-[11.25rem] rounded-20 max-lg:h-[6.6rem] max-lg:w-[9.8rem]':
                    size === 'large',
                'h-[4.5rem] w-[8.31rem] rounded-8 mobile:w-full':
                    size === 'medium',
                'h-[4.5rem] w-[5.375rem] rounded-8 mobile:w-full':
                    size === 'small',
            }"
            class="relative overflow-hidden bg-gradient-to-tr from-[#894BFF80] to-[#743FDA80] max-[20rem]:h-12">
            <picture
                v-if="isShowNoise"
                class="absolute h-full w-full opacity-30">
                <source
                    type="image/webp"
                    srcset="/assets/images/ui/placeholder/webp/noise.webp" />
                <img
                    alt="noise"
                    src="/assets/images/ui/placeholder/jpg-png/noise.png"
                    class="absolute h-full w-full opacity-30" />
            </picture>
            <div
                :class="{
                    'group-hover:-rotate-12 group-hover:scale-110':
                        animation === 'rotate-left',
                    'group-hover:rotate-12 group-hover:scale-110':
                        animation === 'rotate-right',
                    'group-hover:scale-125': animation === 'scale',
                }"
                class="relative mx-auto mt-3 flex justify-center transition-all duration-300 max-[20rem]:h-12">
                <slot />
            </div>
        </div>
        <p
            :class="{
                'text-12/116': size !== 'large',
            }"
            class="mt-1 font-semibold text-ash transition-colors duration-300 group-hover:text-accent">
            {{ title }}
        </p>
    </NuxtLink>
</template>

<script setup lang="ts">
defineProps({
    title: {
        type: String as PropType<string>,
        required: true,
    },
    image: {
        type: String as PropType<string>,
        default: '',
    },
    to: {
        type: String as PropType<string>,
        required: true,
    },
    animation: {
        type: String as PropType<
            'rotate-right' | 'rotate-left' | 'scale' | 'none'
        >,
        default: 'none',
    },
    size: {
        type: String as PropType<'small' | 'medium' | 'large'>,
        default: 'large',
    },
    isShowNoise: {
        type: Boolean,
        default: true,
    },
})
</script>
